import { render } from "./FormManager.vue?vue&type=template&id=6ff7925c&scoped=true"
import script from "./FormManager.vue?vue&type=script&lang=js"
export * from "./FormManager.vue?vue&type=script&lang=js"

import "./FormManager.vue?vue&type=style&index=0&id=6ff7925c&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ff7925c"]])

export default __exports__
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpace,QBtn,QBanner,QInnerLoading,QTable,QTd,QDialog,QCard,QCardSection,QCardActions});qInstall(script, 'directives', {ClosePopup});
